import merge from 'lodash/merge'
import { KEYCLOAK_SESSION } from '../actions/keycloak-actions'

const initialState = { }

export default (state = initialState, action) => {
  switch(action.type) {
    case KEYCLOAK_SESSION: return merge({}, state, action.keycloakSession)
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/keycloak-reducers.js